import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};

export const getAllOverallScvTrips = async (startDate, endDate,ownerType,vehicleType) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `SCVReport/SCVOverAllTripToTransferStationReport?StartDate=${startDate}&EndDate=${endDate}&OwnerTypeId=${ownerType}&VehicleTypeId=${vehicleType}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOverallTripsInnerReportTransaction = async (StartDate, endDate,zoneId,circleId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTransaction?startDate=${StartDate}&endDate=${endDate}&zoneId=${zoneId}&circleId=${circleId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getOneTimeTripsInnerReportTransaction = async (StartDate, endDate,zoneId,circleId,collectionTypeId,transferStationId,ownerType,vehicleType) => {
  const ownerId = ownerType == null ? '' : ownerType;
  // const loadingId = LoadingEquipmentId === null ? '' : LoadingEquipmentId;
  const vehicleId = vehicleType == null ? '' : vehicleType;
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTripOneTransaction?startDate=${StartDate}&endDate=${endDate}&zoneId=${zoneId}&circleId=${circleId}&collectionTypeId=${collectionTypeId}&transferStationId=${transferStationId}&OwnerTypeId=${ownerId}&VehicleTypeId=${vehicleId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOneTimeTripsInnerReportTotalTransaction = async (StartDate, endDate,collectionTypeId,transferStationId,ownerType,vehicleType) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTripOneTransaction?startDate=${StartDate}&endDate=${endDate}&collectionTypeId=${collectionTypeId}&transferStationId=${transferStationId}&OwnerTypeId=${ownerType}&VehicleTypeId=${vehicleType}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getTwoTimeTripsInnerReportTransaction = async (StartDate, endDate,zoneId,circleId,collectionTypeId,transferStationId,ownerType,vehicleType) => {
  const ownerId = ownerType == null ? '' : ownerType;
  // const loadingId = LoadingEquipmentId === null ? '' : LoadingEquipmentId;
  const vehicleId = vehicleType == null ? '' : vehicleType;
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTripTwoTransaction?startDate=${StartDate}&endDate=${endDate}&zoneId=${zoneId}&circleId=${circleId}&collectionTypeId=${collectionTypeId}&transferStationId=${transferStationId}&OwnerTypeId=${ownerId}&VehicleTypeId=${vehicleId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getTwoTimeTripsInnerReportTotalTransaction = async (StartDate, endDate,collectionTypeId,transferStationId,ownerType,vehicleType) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTripTwoTransaction?startDate=${StartDate}&endDate=${endDate}&collectionTypeId=${collectionTypeId}&transferStationId=${transferStationId}&OwnerTypeId=${ownerType}&VehicleTypeId=${vehicleType}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getThreeTimeTripsInnerReportTransaction = async (StartDate, endDate,zoneId,circleId,collectionTypeId,transferStationId,ownerType,vehicleType) => {
  const ownerId = ownerType == null ? '' : ownerType;
  // const loadingId = LoadingEquipmentId === null ? '' : LoadingEquipmentId;
  const vehicleId = vehicleType == null ? '' : vehicleType;
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTripThreeTransaction?startDate=${StartDate}&endDate=${endDate}&zoneId=${zoneId}&circleId=${circleId}&collectionTypeId=${collectionTypeId}&transferStationId=${transferStationId}&OwnerTypeId=${ownerId}&VehicleTypeId=${vehicleId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getThreeTimeTripsInnerReportTotalTransaction = async (StartDate, endDate,collectionTypeId,transferStationId,ownerType,vehicleType) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTripThreeTransaction?startDate=${StartDate}&endDate=${endDate}&collectionTypeId=${collectionTypeId}&transferStationId=${transferStationId}&OwnerTypeId=${ownerType}&VehicleTypeId=${vehicleType}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getFourTimeTripsInnerReportTransaction = async (StartDate, endDate,zoneId,circleId,collectionTypeId,transferStationId,ownerType,vehicleType) => {
  const ownerId = ownerType == null ? '' : ownerType;
  // const loadingId = LoadingEquipmentId === null ? '' : LoadingEquipmentId;
  const vehicleId = vehicleType == null ? '' : vehicleType;
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTripFourTransaction?startDate=${StartDate}&endDate=${endDate}&zoneId=${zoneId}&circleId=${circleId}&collectionTypeId=${collectionTypeId}&transferStationId=${transferStationId}&OwnerTypeId=${ownerId}&VehicleTypeId=${vehicleId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getFourTimeTripsInnerReportTotalTransaction = async (StartDate, endDate,collectionTypeId,transferStationId,ownerType,vehicleType) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTripFourTransaction?startDate=${StartDate}&endDate=${endDate}&collectionTypeId=${collectionTypeId}&transferStationId=${transferStationId}&OwnerTypeId=${ownerType}&VehicleTypeId=${vehicleType}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getMoreThanFourTimeTripsInnerReportTransaction = async (StartDate, endDate,zoneId,circleId,collectionTypeId,transferStationId,ownerType,vehicleType) => {
  const ownerId = ownerType == null ? '' : ownerType;
  // const loadingId = LoadingEquipmentId === null ? '' : LoadingEquipmentId;
  const vehicleId = vehicleType == null ? '' : vehicleType;
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTripFiveOrMoreTransaction?startDate=${StartDate}&endDate=${endDate}&zoneId=${zoneId}&circleId=${circleId}&collectionTypeId=${collectionTypeId}&transferStationId=&OwnerTypeId=${ownerId}&VehicleTypeId=${vehicleId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};


export const getMoreThanFourTimeTripsInnerReportTotalTransaction = async (StartDate, endDate,collectionTypeId,transferStationId,ownerType,vehicleType) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTripFiveOrMoreTransaction?startDate=${StartDate}&endDate=${endDate}&collectionTypeId=${collectionTypeId}&transferStationId=${transferStationId}&OwnerTypeId=${ownerType}&VehicleTypeId=${vehicleType}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};



export const getAllOverallOneScvCollectionTransaction = async (StartDate, endDate,zoneId,circleId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllSecondaryCollectionOneTimeTransaction?startDate=${StartDate}&endDate=${endDate}&zoneId=${zoneId}&circleId=${circleId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllOverallTwoScvCollectionTransaction = async (StartDate, endDate,zoneId,circleId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllSecondaryCollectionTwoTimeTransaction?startDate=${StartDate}&endDate=${endDate}&zoneId=${zoneId}&circleId=${circleId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getAllOverallThreeScvCollectionTransaction = async (StartDate, endDate,zoneId,circleId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllSecondaryCollectionTwoTimeTransaction?startDate=${StartDate}&endDate=${endDate}&zoneId=${zoneId}&circleId=${circleId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllOverallFourScvCollectionTransaction = async (StartDate, endDate,zoneId,circleId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllSecondaryCollectionTwoTimeTransaction?startDate=${StartDate}&endDate=${endDate}&zoneId=${zoneId}&circleId=${circleId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

